"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timestampToISO = timestampToISO;
exports.timestampToDate = timestampToDate;
exports.ISOToTimestamp = ISOToTimestamp;
exports.maybeDecimalToNumber = maybeDecimalToNumber;
exports.decimalToNumber = decimalToNumber;
exports.numberToDecimal = numberToDecimal;
const timestamp_pb_1 = require("google-protobuf/google/protobuf/timestamp_pb");
const decimal_pb_1 = require("@taxfyle/api-internal-node/shared/types/decimal_pb");
const nanoFactor = 1000000000;
/**
 * Converts a proto Timestamp to an ISO8601 string date
 * @param timestamp The timestamp to convert either in Timestamp protobuf
 * format or as an object
 */
function timestampToISO(timestamp) {
    if (!timestamp) {
        return timestamp;
    }
    if ('toDate' in timestamp) {
        return timestamp.toDate().toISOString();
    }
    else {
        return new Date(timestamp.seconds * 1000 + timestamp.nanos / 1000000).toISOString();
    }
}
/**
 * Converts a proto Timestamp to a date
 * @param timestamp The timestamp to convert either in Timestamp protobuf
 * format or as an object
 */
function timestampToDate(timestamp) {
    if (!timestamp) {
        return timestamp;
    }
    if ('toDate' in timestamp) {
        return timestamp.toDate();
    }
    else {
        return new Date(timestamp.seconds * 1000 + timestamp.nanos / 1000000);
    }
}
/**
 * Creates a timestamp from an ISO representation.
 *
 * @param iso
 * @constructor
 */
function ISOToTimestamp(iso) {
    const timestamp = new timestamp_pb_1.Timestamp();
    timestamp.fromDate(new Date(iso));
    return timestamp;
}
function maybeDecimalToNumber(value) {
    return value ? decimalToNumber(value) : 0;
}
/**
 * Converts a proto custom Decimal type into a Number
 * @param decimal The decimal to convert either in Decimal protobuf format or as
 * an object
 */
function decimalToNumber(decimal) {
    if ('getUnits' in decimal) {
        return decimal.getUnits() + decimal.getNanos() / nanoFactor;
    }
    else {
        return decimal.units + decimal.nanos / nanoFactor;
    }
}
/**
 * Converts a Number into a proto custom Decimal type
 *
 * @param number The number to convert to a decimal.
 */
function numberToDecimal(number) {
    const decimal = new decimal_pb_1.Decimal();
    const units = Math.floor(number);
    const nanos = Math.floor((number - units) * nanoFactor);
    decimal.setUnits(units);
    decimal.setNanos(nanos);
    return decimal;
}
//# sourceMappingURL=grpc-util.js.map